import { Injectable, Inject } from '@angular/core';

// Extend the Window interface to include the reCAPTCHA Enterprise API
declare global {
  interface Window {
    grecaptcha: {
      enterprise: {
        ready(callback: () => void): void;
        execute(siteKey: string, options: { action: string }): Promise<string>;
      };
    };
  }
}


@Injectable({
  providedIn: 'root',
})
export class RecaptchaService {
  constructor(@Inject('RECAPTCHA_V3_SITE_KEY') private siteKey: string) {}

  getSiteKey(): string {
    return this.siteKey;
  }

  private waitForGrecaptcha(interval = 50, timeout = 5000): Promise<void> {
    return new Promise((resolve, reject) => {
      const startTime = Date.now();

      const checkGrecaptcha = () => {
        if (
          typeof window.grecaptcha !== 'undefined' &&
          typeof window.grecaptcha.enterprise?.ready === 'function'
        ) {
          resolve();
        } else if (Date.now() - startTime >= timeout) {
          reject(new Error('Timeout waiting for grecaptcha Enterprise to be ready.'));
        } else {
          setTimeout(checkGrecaptcha, interval);
        }
      };

      checkGrecaptcha();
    });
  }

  getRecaptchaToken(action: string): Promise<string> {
    return this.waitForGrecaptcha()
      .then(
        () =>
          new Promise<string>((resolve, reject) => {
            window.grecaptcha.enterprise.ready(() => {
              window.grecaptcha.enterprise
                .execute(this.siteKey, { action })
                .then(resolve)
                .catch((error: unknown) => {
                  console.error('Error executing reCAPTCHA Enterprise:', error);
                  reject(error);
                });
            });
          })
      )
      .catch((error: unknown) => {
        console.error('Error waiting for reCAPTCHA Enterprise:', error);
        return Promise.reject(error);
      });
  }
}